import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { EquipmentsApi } from 'app/main/equipments/services/api/equipments.api';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EquipmentMaintenanceMapperService } from './services/tab-maintenances.service';
import { UpdatedByService } from './services/updated-by.service';
var TabMaintenancesComponent = /** @class */ (function () {
    function TabMaintenancesComponent(dialogData, equipmentMaintenanceMapper, authenticationService, maintenancesApi, updatedService, matDialog, equipmentApi) {
        this.dialogData = dialogData;
        this.equipmentMaintenanceMapper = equipmentMaintenanceMapper;
        this.authenticationService = authenticationService;
        this.maintenancesApi = maintenancesApi;
        this.updatedService = updatedService;
        this.matDialog = matDialog;
        this.equipmentApi = equipmentApi;
        this.isOpeningEquipmentMaintenanceDialog = false;
        this.equipmentMaintenancesMapped = [];
        this.hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
        this.isLoadedAllTheMaintenances = false;
        this.loading = false;
        this.offset = 0;
        this.limit = 25;
        this.hasMoreMaintenances = true;
        this.subscriptions = new Subject();
    }
    TabMaintenancesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.equipment = this.dialogData.equipment;
                        fromEvent(this.scrollableContent.nativeElement, 'scroll').pipe(takeUntil(this.subscriptions), filter(function () { return _this.isOnEndOfThePage() && _this.hasMoreMaintenances; }), tap(function () { return _this.loading = true; }), debounceTime(500), switchMap(function () { return _this.loadMoreMaintenances(); })).subscribe();
                        return [4 /*yield*/, this.loadMoreMaintenances()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabMaintenancesComponent.prototype.ngOnDestroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.subscriptions.next();
                this.subscriptions.complete();
                return [2 /*return*/];
            });
        });
    };
    TabMaintenancesComponent.prototype.loadMoreMaintenances = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenances;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.equipmentApi.findEquipmentMaintenances(this.equipment.id, this.offset, this.limit)
                                .then(function (result) { return _this.equipmentMaintenanceMapper.toEquipmentMaintenancesMapped(result); })
                                .then(function (result) { return _this.updatedService.customUpdatedByIn(result); })];
                    case 1:
                        maintenances = _b.sent();
                        (_a = this.equipmentMaintenancesMapped).push.apply(_a, tslib_1.__spread(maintenances));
                        this.offset = this.equipmentMaintenancesMapped.length;
                        this.hasMoreMaintenances = maintenances.length === this.limit;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabMaintenancesComponent.prototype.openEquipmentMaintenanceDialog = function (maintenanceId) {
        var _this = this;
        this.isOpeningEquipmentMaintenanceDialog = true;
        this.maintenancesApi.searchOne(maintenanceId).subscribe(function (maintenance) {
            var maintenanceDialog = _this.matDialog.open(DialogEditMaintenanceComponent, {
                panelClass: 'dialog-edit-maintenance',
                data: {
                    maintenance: maintenance,
                    isViewMode: !_this.hasEditMaintenancePermission
                }
            });
            maintenanceDialog.afterClosed().subscribe(function () {
                _this.isOpeningEquipmentMaintenanceDialog = false;
            });
        });
    };
    TabMaintenancesComponent.prototype.isOnEndOfThePage = function () {
        var _a = this.scrollableContent.nativeElement, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight, scrollTop = _a.scrollTop;
        return Math.abs(scrollHeight - clientHeight - scrollTop) < 1;
    };
    return TabMaintenancesComponent;
}());
export { TabMaintenancesComponent };
